import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SeoHelmet from './pages/components/SeoHelmet';
import Navbar from './pages/components/Navbar';
import Floater from './pages/components/Floater';
import WspButton from './pages/components/WspButton';
import Home from './pages/Home';
import CustomSoftwareDevelopment from './pages/CustomSoftwareDevelopment';
import Footer from './pages/components/Footer';
import ArtificialIntelligence from './pages/ArtificialIntelligence';
import AiAgentDevelopment from './pages/AiAgentDevelopment';
import MVP from './pages/MVP';
import WebsiteAndAppDevelopment from './pages/WebsiteAndAppDevelopment';
import ProductDevelopment from './pages/ProductDevelopment';
import EnterpriseWebDevelopment from './pages/EnterpriseWebDevelopment';
import BlockChainDevelopment from './pages/BlockChainDevelopment';
import CaseStudyPage from './pages/CaseStudyPage';
import ClientTestiminials from './pages/ClientTestimonials';
import ContactUs from './pages/ContactUs';
import ThankYou from './pages/ThankYou';
import Services from './pages/Services';
import Healthcare from './pages/Healthcare';
import Fintech from './pages/Fintech';
import Retail from './pages/Retail';
import EntertainmentGaming from './pages/EntertainmentGaming';
import MediaCommunication from './pages/MediaCommunication';
import OffshoreDevelopment from './pages/OffshoreDevelopment';
import LinkedInConnect from './pages/components/LinkedInConnect';
import ProductPage from './pages/ProductPage';
import CoreSyncErp from './pages/CoreSyncErp';
import PlayMind from './pages/PlayMind';
import { FaSpinner } from 'react-icons/fa';
import UxGenie from './pages/UxGenie';
import RetailNova from './pages/RetailNova';
import FinSightX from './pages/FinSightX';
import GamerGrid from './pages/GamerGrid';
import MediCoreErp from './pages/MediCoreErp';
import EduMind from './pages/EduMind';
// import RementeApp from './pages/RementeApp';
import HriasPricing from './pages/HriasPricing';
import B2bLeadDatabase from './pages/B2bLeadDatabase';
import EmailFinderVerifier from './pages/EmailFinderVerifier';
import PhoneNumberList from './pages/PhoneNumberList';
import MultiChannelSequence from './pages/MultiChannelSequence';
import MultichannelSequenceb2c from './pages/MultichannelSequenceb2c';
import LinkedInProspecting from './pages/LinkedInProspecting';
import WhatsAppProspecting from './pages/WhatsAppProspecting';
import InAppCalling from './pages/InAppCalling';
import AiPersonalization from './pages/AiPersonalization';
import UnifiedInBox from './pages/UnifiedInBox';
import B2cLeadDatabase from './pages/B2cLeadDatabase';
import HriasPricingB2c from './pages/HriasPricingB2c';
import FacebookProspecting from './pages/FacebookProspecting';
import PhoneNumberListB2C from './pages/PhoneNumberListB2C';
import ContactUsHrias from './pages/ContactUsHrias';
import CaseStudyHriasB2B from './pages/CaseStudyHriasB2B';
import CaseStudyB2C from './pages/CaseStuduB2C';
import StrategyPowerGroup from './pages/StrategyPowerGroup';
import Sociazy from './pages/Sociazy';
import AstraLogic from './pages/AstraLogic';
import IronBridge from './pages/IronBridge';
import PrimeCore from './pages/PrimeCore';
import Huckberry from './pages/Huckberry';
import OrangeHRM from './pages/OrangeHRM';
import MyLondonHome from './pages/MyLondonHome';
import GoCardless from './pages/GoCardless';
import InFusion from './pages/InFusion';
import OfficeManagementSoftware from './pages/OfficeManagementSoftware';
import WorkflowAutomationSoftware from './pages/WorkflowAutomationSoftware';
import BlogPage from './pages/BlogPage';
import InvoiceApprovalSoftware from './pages/InvoiceApprovalSoftware';
import TheFutureofAI from './pages/TheFutureofAI';
import AlgoTradingSoftware from './pages/AlgoTradingSoftware';
import CustomERPSolutions from './pages/CustomERPSolutions';
import CyberSecuritySAAS from './pages/CyberSecuritySAAS';
import CustomWebAppDevelopmentPeregrinee from './pages/CustomWebAppDevelopmentPeregrinee';
import WebAppDevPeregrinee from './pages/WebAppDevPeregrinee';
import WhyBusinessesChoosePeregrinee from './pages/WhyBusinessesChoosePeregrinee';
import HighPerformanceWebApplications from './pages/HighPerformanceWebApplications';
import MVPDevelopmentForStartups from './pages/MVPDevelopmentForStartups';
import CostToBuildWebApp2026 from './pages/CostToBuildWebApp2026';
import NewsletterPopup from './pages/components/NewsletterPopup';
import ReactVsAngularVsVue from './pages/ReactVsAngularVsVue';
import AIInWebApplicationDevelopment from './pages/AIInWebApplicationDevelopment';
import SaaSWebApplicationDevelopment from './pages/SaaSWebApplicationDevelopment';
import FintechWebAppDevelopment from './pages/FintechWebAppDevelopment';
import VisitorTrackAI from './pages/VisitorTrackAI';
import DigitalMarketing from './pages/DigitalMarketing';
import BlueBoxMedia from './pages/BlueBoxMedia';
import Portfolio from './pages/Portfolio';
import S51Agency from './pages/S51Agency';

const Loader = () => (
  <div style={{
    height: '100vh',
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    position: 'fixed',
    top: 0,
    left: 0
  }}>
    <FaSpinner style={{
      fontSize: '3rem',
      color: '#275E76',
      animation: 'spin 1s linear infinite'
    }} />
    <style>{`
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const hideUI = ['/thankyou', '/portfolio'].includes(location.pathname);

  // Load listener on route change
  useEffect(() => {
    setIsLoading(true);

    // Wait for all assets to load
    const handleLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === 'complete') {
      setTimeout(handleLoad, 300); // slight delay to feel smooth
    } else {
      window.addEventListener('load', handleLoad);
      return () => window.removeEventListener('load', handleLoad);
    }
  }, [location.pathname]);

  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          <SeoHelmet />
          {/* {!hideUI && <NewsletterPopup />} */}
          {!hideUI && <Navbar />}
          {!hideUI && <Floater />}
          {!hideUI && <WspButton />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/custom-software-development" element={<CustomSoftwareDevelopment />} />
            <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
            <Route path="/ai-agent-development" element={<AiAgentDevelopment />} />
            <Route path="/minimum-viable-product" element={<MVP />} />
            <Route path="/website-and-app-development" element={<WebsiteAndAppDevelopment />} />
            <Route path="/product-development" element={<ProductDevelopment />} />
            <Route path="/enterprise-web-development" element={<EnterpriseWebDevelopment />} />
            <Route path="/blockchain-development" element={<BlockChainDevelopment />} />
            <Route path="/case-studies" element={<CaseStudyPage />} />
            <Route path="/client-testimonials" element={<ClientTestiminials />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/contact-us-hrias" element={<ContactUsHrias />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/services" element={<Services />} />
            <Route path="/healthcare" element={<Healthcare />} />
            <Route path="/fintech" element={<Fintech />} />
            <Route path="/retail" element={<Retail />} />
            <Route path="/entertainment-gaming" element={<EntertainmentGaming />} />
            <Route path="/media-communications" element={<MediaCommunication />} />
            <Route path="/offshore-development" element={<OffshoreDevelopment />} />
            <Route path="/hrias-by-peregrinee" element={<ProductPage />} />
            <Route path="/hrias-b2b-pricing" element={<HriasPricing />} />
            <Route path="/hrias-b2c-pricing" element={<HriasPricingB2c />} />
            <Route path="/hrias-b2b-lead-database" element={<B2bLeadDatabase />} />
            <Route path="/hrias-b2c-lead-database" element={<B2cLeadDatabase />} />
            <Route path="/hrias-email-finder-and-verifier" element={<EmailFinderVerifier />} />
            <Route path="/hrias-phone-number-list" element={<PhoneNumberList />} />
            <Route path="/hrias-phone-number-list-b2c" element={<PhoneNumberListB2C />} />
            <Route path="/hrias-multi-channel-sequence" element={<MultiChannelSequence />} />
            <Route path="/hrias-multi-channel-sequence-b2c" element={<MultichannelSequenceb2c />} />
            <Route path="/hrias-linkedin-prospecting" element={<LinkedInProspecting />} />
            <Route path="/hrias-facebook-prospecting" element={<FacebookProspecting />} />
            <Route path="/hrias-whatsapp-prospecting" element={<WhatsAppProspecting />} />
            <Route path="/hrias-in-app-calling" element={<InAppCalling />} />
            <Route path="/hrias-ai-personalization" element={<AiPersonalization />} />
            <Route path="/hrias-unified-inbox" element={<UnifiedInBox />} />
            <Route path="/coresync-erp" element={<CoreSyncErp />} />
            <Route path="/play-mind" element={<PlayMind />} />
            <Route path="/uxgenie" element={<UxGenie />} />
            <Route path="/retailnova" element={<RetailNova />} />
            <Route path="/finsightx" element={<FinSightX />} />
            <Route path="/gamergrid" element={<GamerGrid />} />
            <Route path="/medicore-erp" element={<MediCoreErp />} />
            {/* <Route path="/edumind" element={<EduMind />} /> */}
            {/* <Route path="/remente" element={<RementeApp />} /> */}
            <Route path="/case-study-hrias-b2b" element={<CaseStudyHriasB2B />} />
            <Route path="/case-study-hrias-b2c" element={<CaseStudyB2C />} />
            <Route path="/strategy-power-group" element={<StrategyPowerGroup />} />
            <Route path="/sociazy" element={<Sociazy />} />
            <Route path="/astra-logic" element={<AstraLogic />} />
            <Route path="/iron-bridge" element={<IronBridge />} />
            <Route path="/prime-core" element={<PrimeCore />} />
            <Route path="/huckberry" element={<Huckberry />} />
            <Route path="/orangehrm" element={<OrangeHRM />} />
            <Route path="/mylondonhome" element={<MyLondonHome />} />
            <Route path="/gocardless" element={<GoCardless />} />
            <Route path="/infusion" element={<InFusion />} />
            <Route path="/integrated-office-management-software" element={<OfficeManagementSoftware />} />
            <Route path="/workflow-automation-software" element={<WorkflowAutomationSoftware />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/invoice-approval-software" element={<InvoiceApprovalSoftware />} />
            <Route path="/the-future-of-ai-in-ecommerce" element={<TheFutureofAI />} />
            <Route path="/algo-trading-software" element={<AlgoTradingSoftware />} />
            <Route path="/custom-erp-solutions" element={<CustomERPSolutions />} />
            <Route path="/cybersecurity-in-saas" element={<CyberSecuritySAAS />} />
            <Route path="/custom-web-app-development-peregrinee" element={<CustomWebAppDevelopmentPeregrinee />} />
            <Route path="/web-app-development-at-peregrinee" element={<WebAppDevPeregrinee />} />
            <Route path="/why-businesses-choose-peregrinee" element={<WhyBusinessesChoosePeregrinee />} />
            <Route path="/high-performance-web-applications" element={<HighPerformanceWebApplications />} />
            <Route path="/mvp-development-for-startups" element={<MVPDevelopmentForStartups />} />
            <Route path="/cost-to-build-web-app-2026" element={<CostToBuildWebApp2026 />} />
            <Route path='/react-vs-angular-vs-vue' element={<ReactVsAngularVsVue />} />
            <Route path="/ai-in-web-application-development" element={<AIInWebApplicationDevelopment />} />
            <Route path="/saas-web-application-development" element={<SaaSWebApplicationDevelopment />} />
            <Route path="/fintech-web-app-development" element={<FintechWebAppDevelopment />} />
            <Route path="/visitortrack-ai" element={<VisitorTrackAI />} />
            <Route path="/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/bluebox-media" element={<BlueBoxMedia />} />
            {/* <Route path="/s51-agency" element={<S51Agency />} /> */}
            <Route path="/portfolio" element={<Portfolio />} />

            {/* Add more routes as needed */}
          </Routes>
          {!hideUI && <LinkedInConnect />}
          {!hideUI && <Footer />}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
